module.exports = __webpack_public_path__ + "img/navy-ribbon.0d91c138.svg";